export const maskTaxId = (taxId) => {
  const digits = `${taxId || ''}`.replace(/\D/g, '');
  const lastFour = digits.slice(-4);

  if (!lastFour) {
    return '***-**-****';
  }

  return `***-**-${lastFour.padStart(4, '*')}`;
};
